<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('drawer_title_createCustomer') || '创建新客户'"
      visible
      direction="rtl"
      :size="1200"
      @close="() => cancel()"
    >
      <div class="drawer-main">
        <Main ref="main" @close="close" @reload="$emit('reload')" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
  },
  methods: {
    async cancel() {
      this.$confirm(
        this.$l('tips_confirm_closeCreate') || '是否确认关闭当前操作界面？',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确认',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        }
      ).then(() => this.close())
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
